import React from "react"
import { SelectSeeker } from "@ui-seeker/core"


export default function AppCommonFiltersCurrencySelect({ ...props }) {
	return <SelectSeeker
		label="Currency"
		value={idCurrency.value}
		onChange={e => idCurrency.value = e.target.value}
		options={[
			{ label: 'Eur', value: 'EUR' },
			{ label: 'Gbp', value: 'GBP' },
			{ label: 'Usd', value: 'USD' }
		]}
		{...props}
	/>
}